"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkCard = exports.StyledLinkCard = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _CardActionArea = _interopRequireDefault(require("@material-ui/core/CardActionArea"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _clsx = _interopRequireDefault(require("clsx"));

var _icons = require("../icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var urlPattern = /^https?:\/\//;

function urlIsExternal(urlString) {
  return urlPattern.test(urlString);
}

var LinkCard =
/*#__PURE__*/
function (_Component) {
  _inherits(LinkCard, _Component);

  function LinkCard() {
    _classCallCheck(this, LinkCard);

    return _possibleConstructorReturn(this, _getPrototypeOf(LinkCard).apply(this, arguments));
  }

  _createClass(LinkCard, [{
    key: "renderCard",
    value: function renderCard() {
      var _this$props = this.props,
          classes = _this$props.classes,
          Icon = _this$props.icon,
          href = _this$props.href,
          title = _this$props.title,
          flavour = _this$props.flavour,
          hrHref = _this$props.hrHref;
      return _react.default.createElement(_CardContent.default, {
        className: classes.cardaction
      }, _react.default.createElement("div", {
        className: classes.titleIcon
      }, Icon ? _react.default.createElement(Icon, {
        color: "primary",
        className: classes.icon
      }) : _react.default.createElement("div", {
        className: classes.noIcon
      }), urlIsExternal(href) ? _react.default.createElement(_icons.LaunchIcon, {
        color: "primary",
        className: classes.externalIcon
      }) : null), _react.default.createElement(_Typography.default, {
        gutterBottom: true,
        variant: "h6",
        color: "primary"
      }, title), _react.default.createElement(_Typography.default, {
        variant: "body2"
      }, flavour), hrHref && _react.default.createElement("div", {
        className: classes.linkcontainer
      }, _react.default.createElement(_Typography.default, {
        variant: "body2",
        color: "primary"
      }, hrHref.toUpperCase())));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$classes = _this$props2.classes,
          link = _this$props2$classes.link,
          cardaction = _this$props2$classes.cardaction,
          disabledLink = _this$props2$classes.disabledLink,
          className = _this$props2.className,
          loading = _this$props2.loading,
          disabled = _this$props2.disabled;
      var href = this.props.href;

      if (loading || disabled) {
        return _react.default.createElement(_Card.default, {
          className: (0, _clsx.default)(className)
        }, _react.default.createElement(_CardActionArea.default, {
          className: (0, _clsx.default)(cardaction, (loading || disabled) && disabledLink),
          disabled: true
        }, this.renderCard()), loading && _react.default.createElement(_LinearProgress.default, {
          color: "primary"
        }));
      }

      if (href) {
        return _react.default.createElement(_Card.default, {
          className: (0, _clsx.default)(className)
        }, urlIsExternal(href) ? _react.default.createElement("a", {
          href: href,
          className: link
        }, _react.default.createElement(_CardActionArea.default, {
          className: cardaction
        }, this.renderCard())) : _react.default.createElement(_reactRouterDom.Link, {
          to: href || './',
          className: link
        }, _react.default.createElement(_CardActionArea.default, {
          className: cardaction
        }, this.renderCard())));
      }

      return _react.default.createElement(_Card.default, {
        className: (0, _clsx.default)(className)
      }, this.renderCard(true));
    }
  }]);

  return LinkCard;
}(_react.Component);

exports.LinkCard = LinkCard;
LinkCard.propTypes = {
  classes: _propTypes.default.object.isRequired,
  icon: _propTypes.default.func,
  title: _propTypes.default.any.isRequired,
  href: _propTypes.default.string,
  flavour: _propTypes.default.any,
  hrHref: _propTypes.default.string,

  /** Truthy/falsy value to indicate if the component is "loading".
   * Changes the apperance to indicate so. */
  loading: _propTypes.default.any,

  /** Truthy/falsy value to indicate if the component is "disabled".
   * Changes the apperance to indicate so. */
  disabled: _propTypes.default.any,

  /** className of the top level Card-component */
  className: _propTypes.default.any
};
LinkCard.defaultProps = {
  flavour: '',
  href: '',
  icon: null,
  hrHref: null,
  loading: false,
  className: undefined,
  disabled: false
};

var styles = function styles(theme) {
  return {
    link: {
      'text-decoration': 'none',
      '&:onClick': {
        'text-decoration': 'none',
        color: theme.palette.primary.main,
        backgroundColor: 'none'
      },
      '&:active': {
        'text-decoration': 'none',
        color: theme.palette.primary.dark,
        backgroundColor: 'none'
      },
      '&:onFocus': {
        'text-decoration': 'none',
        color: 'none',
        backgroundColor: 'none'
      }
    },
    disabledLink: {
      color: 'currentColor',
      opacity: '0.5',
      textDecoration: 'none'
    },
    icon: {
      width: '3rem',
      height: '3rem'
    },
    externalIcon: {
      float: 'right'
    },
    cardaction: {
      height: '100%',
      width: '100%'
    },
    noIcon: {
      height: '0.8rem'
    },
    linkcontainer: {
      float: 'right',
      marginBottom: '0.8rem'
    },
    spinnerWrapper: {
      position: 'relative'
    },
    spinner: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  };
};

var StyledLinkCard = (0, _styles.withStyles)(styles)(LinkCard);
exports.StyledLinkCard = StyledLinkCard;